/**
 * @generated SignedSource<<c76309ebecc567e6d2035e662ccfac45>>
 * @relayHash 079ff2d8b9d5ae3ff6e21263b139d2b8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7c22267004bc2fd98425f3cabd602d7426662a324fb451ca2cea2f794671999f

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type LicenseStatus = "ACTIVE" | "SUSPENDED" | "UNLICENSED" | "%future added value";
export type useLoomTenantProvisionStatusQuery$variables = Record<PropertyKey, never>;
export type useLoomTenantProvisionStatusQuery$data = {
  readonly confluence_tenantContext: {
    readonly licensedProducts: ReadonlyArray<{
      readonly licenseStatus: LicenseStatus;
      readonly productKey: string;
    }>;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"loomPersonalization_tenant">;
};
export type useLoomTenantProvisionStatusQuery$rawResponse = {
  readonly confluence_tenantContext: {
    readonly licensedProducts: ReadonlyArray<{
      readonly licenseStatus: LicenseStatus;
      readonly productKey: string;
    }>;
  } | null;
};
export type useLoomTenantProvisionStatusQuery = {
  rawResponse: useLoomTenantProvisionStatusQuery$rawResponse;
  response: useLoomTenantProvisionStatusQuery$data;
  variables: useLoomTenantProvisionStatusQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "concreteType": "ConfluenceTenantContext",
  "kind": "LinkedField",
  "name": "confluence_tenantContext",
  "plural": false,
  "selections": [
    {
      "concreteType": "LicensedProduct",
      "kind": "LinkedField",
      "name": "licensedProducts",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "licenseStatus"
        },
        {
          "kind": "ScalarField",
          "name": "productKey"
        }
      ]
    }
  ]
},
v1 = [
  (v0/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useLoomTenantProvisionStatusQuery",
    "selections": [
      (v0/*: any*/),
      {
        "kind": "InlineDataFragmentSpread",
        "name": "loomPersonalization_tenant",
        "selections": (v1/*: any*/),
        "argumentDefinitions": []
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useLoomTenantProvisionStatusQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "079ff2d8b9d5ae3ff6e21263b139d2b8",
    "id": "7c22267004bc2fd98425f3cabd602d7426662a324fb451ca2cea2f794671999f",
    "metadata": {},
    "name": "useLoomTenantProvisionStatusQuery",
    "operationKind": "query",
    "text": "query useLoomTenantProvisionStatusQuery{confluence_tenantContext{licensedProducts{licenseStatus,productKey}},...loomPersonalization_tenant}fragment loomPersonalization_tenant on Query{confluence_tenantContext{licensedProducts{licenseStatus,productKey}}}"
  }
};
})();

(node as any).hash = "1993131921e1f069e2bc354ee5138882";

export default node;
